
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 18.316c0-.654-.531-1.184-1.184-1.184H5.684a1.185 1.185 0 000 2.368h12.632c.653 0 1.184-.531 1.184-1.184zm0-6.316c0-.654-.531-1.184-1.184-1.184H5.684a1.185 1.185 0 000 2.368h12.632c.653 0 1.184-.53 1.184-1.184zm0-6.316c0-.653-.531-1.184-1.184-1.184H5.684a1.185 1.185 0 000 2.368h12.632c.653 0 1.184-.53 1.184-1.184z"}})])
          )
        }
      }
    